<template>
    <div class="animated revealUp">
        <div class="white-wrapper">
            <div class="section-title">
                Numero Reports
            </div>
            <div class="mt-3 mb-2">
                <div class="row">
                    <div class="col-lg-4 col-xl-4 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                            <label :class="dropDown.cinemas && dropDown.cinemas.length > 0
                                ? 'shift-up'
                                : ''
                                ">{{ $t("select") }} {{ $tc("cinema", 1) }}</label>
                            <multiselect :disabled="isRoleID" :options="dropDown.cinemas"
                                v-model="dropDown.selectedCinema" :searchable="true" label="cine_name"
                                track-by="cine_id" placeholder="Select Cinema" @input="onSelectCinema($event)"
                                :allowEmpty="false" :showLabels="false"></multiselect>
                        </div>
                    </div>
                    <div class="col-lg-4 col-xl-4 align-self-center mb-3">
                        <div class="dropdown-curve-container">
                            <label :class="selectedDataType ? 'shift-up' : ''">Data Type</label>
                            <multiselect :disabled="isRoleID" :options="dataType" v-model="selectedDataType"
                                :searchable="true" label="typeName" track-by="type" placeholder="" :allowEmpty="false"
                                :showLabels="false">
                            </multiselect>
                        </div>
                    </div>
                    <div class="col-lg-4 col-xl-3 align-self-center mb-3">
                        <div class="input-material">
                            <div class="add-datepicker">
                                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                                <Datepicker :monday-first="true" type="date" ref="programaticOpen" v-model="fromDate"
                                    v-validate="'required'"></Datepicker>
                                <label :class="fromDate ? 'active' : ''">
                                    <!-- {{ $t("show") }} -->
                                    {{ selectedDataType && selectedDataType.type == 1 ? "File Synced Date" : "From Date"
                                    }}
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-xl-3 align-self-center mb-3"
                        v-if="selectedDataType && selectedDataType.type == 2">
                        <div class="input-material">
                            <div class="add-datepicker">
                                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                                <Datepicker :monday-first="true" ref="programaticOpen" v-model="toDate"
                                    v-validate="'required'">
                                </Datepicker>
                                <label :class="toDate ? 'active' : ''">
                                    <!-- {{ $t("show") }}  -->
                                    {{ $t("todate") }}</label>
                            </div>
                        </div>
                    </div>



                    <div class="col-lg-4 col-xl-4 align-self-center mb-3"
                        v-if="selectedDataType && selectedDataType.type == 1">
                        <div class="dropdown-curve-container">
                            <label :class="selectedReportType ? 'shift-up' : ''">Report Type</label>
                            <multiselect :disabled="isRoleID" :options="reportType" v-model="selectedReportType"
                                :searchable="true" label="typeName" track-by="type" placeholder="" :allowEmpty="false"
                                :showLabels="false">
                            </multiselect>
                        </div>
                    </div>
                    <div class="col-lg-4 col-xl-4 align-self-center mb-3"
                        v-if="selectedReportType && selectedReportType.type == 1">
                        <div class="dropdown-curve-container">
                            <label :class="selectedTimeData ? 'shift-up' : ''">Time</label>
                            <multiselect :disabled="isRoleID" :options="timeArr" v-model="selectedTimeData"
                                :searchable="true" placeholder="" :allowEmpty="false" :showLabels="false">
                            </multiselect>
                        </div>
                    </div>


                    <div class="col-lg-6 col-xl-2 align-self-center mb-3">
                        <button class="btn-blue-lg w-100" @click.prevent="getNumeroRecords('N', 'N')">
                            {{ $t("fetch") }}
                            {{ $t("report") }}
                        </button>
                    </div>

                    <div v-if="numeroRecords && numeroRecords.hasOwnProperty('sessions') && numeroRecords.sessions.length > 0"
                        class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center">
                        <div class="mx-1">{{ $t("download") }} as:</div>
                        <!-- s -->

                        <a target="_blank" @click="getNumeroRecords('Y', 'N')" title="Download as Excel" download>
                            <img class="mx-1" src="@/assets/img/icons/excel.svg" height="25" width="25" />
                        </a>

                    </div>
                </div>
            </div>
            <div style="overflow-x:scroll;width: auto !important" ref="exportable_table">
                <table class="swc-report-table" border="1">
                    <thead class="bg-lightgrey font-weight-bold">
                        <th>Distributor Name</th>
                        <th>Movie Name</th>
                        <th>Screen</th>
                        <th>Show Date/Time</th>
                        <th>Admits</th>
                        <th>Complimentary Admits</th>
                        <th>Net Amount</th>
                        <th>Tax</th>
                        <th>Gross Amount</th>
                    </thead>
                    <tbody
                        v-if="numeroRecords && numeroRecords.hasOwnProperty('sessions') && numeroRecords.sessions.length > 0">
                        <tr v-for="(numeroObj, numeroIndex) in numeroRecords.sessions" :key="numeroIndex">
                            <td class="text-left">{{ numeroObj.film.distributorName }}</td>
                            <td class="text-left">{{ numeroObj.film.name }}-{{ numeroObj.details.displayFormat }}</td>
                            <td class="text-left">{{ numeroObj.screen }}</td>
                            <td class="text-left">{{ numeroObj.sessionTime }}</td>
                            <td class="text-right">{{ numeroObj.salesByTicketType.reduce((acc, { admits }) => {
                                return acc + +parseFloat(admits)
                            }, 0) }}</td>
                            <td class="text-right">{{
                                numeroObj.salesByTicketType.reduce((acc, { complimentaryAdmits }) => {
                                    return acc + +parseFloat(complimentaryAdmits)
                                }, 0) }}</td>
                            <td class="text-right">{{ numeroObj.salesByTicketType.reduce((acc, { revenueNet }) => {
                                return acc + +parseFloat(revenueNet)
                            }, 0) }}</td>
                            <td class="text-right">{{ numeroObj.salesByTicketType.reduce((acc, { tax }) => {
                                return acc + +parseFloat(tax)
                            }, 0) }}</td>
                            <td class="text-right">{{ numeroObj.salesByTicketType.reduce((acc, { revenueGross }) => {
                                return acc + +parseFloat(revenueGross)
                            }, 0) }}</td>
                        </tr>
                        <tr class="bg-lightgrey">
                            <td class="text-left" colspan="4">Grand Total</td>
                            <td class="text-right">{{ grandTotal.admits }}</td>
                            <td class="text-right">{{ grandTotal.complimentaryAdmits }}</td>
                            <td class="text-right">{{ grandTotal.revenueNet }}</td>
                            <td class="text-right">{{ grandTotal.tax }}</td>
                            <td class="text-right">{{ grandTotal.revenueGross }}</td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="15">
                                <NoRecords />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";
import CinemasService from "@/services/CinemasService";
import xlsx from "json-as-xlsx";
import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
    components: {
        NoRecords,
        VueHtml2pdf,
    },
    data() {
        return {
            BASEURL,
            isRoleID: false,
            submitted: false,
            dropDown: {
                cinemas: [],
                selectedCinema: null,
                selectedCinemaName: null,
                selectedCinemaId: "",
            },
            fromDate: new Date(),
            toDate: new Date(),
            reportType: [{ type: 1, typeName: "Hourly" }, { type: 2, typeName: "Daily" }, { type: 3, typeName: "Weekly" }],
            selectedReportType: null,
            dataType: [{ type: 1, typeName: "Synced Data" }, { type: 2, typeName: "Current Data" }],
            selectedDataType: null,
            timeArr: [
                '00:00-01:00', '01:00-02:00',
                '02:00-03:00', '03:00-04:00',
                '04:00-05:00', '05:00-06:00',
                '06:00-07:00', '07:00-08:00',
                '08:00-09:00', '09:00-10:00',
                '10:00-11:00', '11:00-12:00',
                '12:00-13:00', '13:00-14:00',
                '14:00-15:00', '15:00-16:00',
                '16:00-17:00', '17:00-18:00',
                '18:00-19:00', '19:00-20:00',
                '20:00-21:00', '21:00-22:00',
                '22:00-23:00', '23:00-00:00'
            ],
            selectedTimeData: "",
            numeroRecords: [],
            excelFilePath: "",
            grandTotal: {},
        };
    },
    beforeMount() {
        let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
        const { cinema_id } = this.secureStore.get("USINFO");
        this.getCinemaList(cinema_id);
        // if (CinemaObj) {
        //   this.onSelectCinema(CinemaObj);
        // }
    },
    watch: {
        // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
        //   if (CinemaObj) {
        //     this.onSelectCinema(CinemaObj);
        //   }
        // },
        excelFilePath(value) {
            this.excelFilePath = value;
        },
    },
    mounted() { },
    methods: {
        moment,
        ExportExcel(type, fn, dl) {
            var elt = this.$refs.exportable_table;
            var wb = XLSX.utils.table_to_book(elt, {
                sheet: `RawMaterialSupplierWise`,
            });
            return dl
                ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
                : XLSX.writeFile(
                    wb,
                    fn ||
                    `RawMaterialSupplierWiseCost-${this.dropDown.selectedCinemaName
                    }.${type || "xlsx"}`
                );
        },
        getCinemaList: function (cinema_id) {
            MasterService.GetCinemas({cine_id: cinema_id})
                .then((response) => {
                    const { data } = response;
                    if (data.status && data.Records.length > 0) {
                        this.dropDown.cinemas = data.Records;
                        this.CinemasCopy = data.Records;
                    } else {
                        this.$toasted.show(data.message);
                    }
                })
                .catch(this._CatchError);
        },
        onSelectCinema: function (event) {
            this.dropDown.selectedCinema = event;
            this.dropDown.selectedCinemaName = event.cine_name;
            this.dropDown.selectedCinemaId = event.cine_id;
            this.$store.dispatch("selectDropdownCinema", event);
        },
        getNumeroRecords(isExcel = "N", isPdf = "N") {
            this.numeroRecords = [];
            if (!this.dropDown.selectedCinemaId) {
                return this.$toasted.show("Select Cinema");
            }
            if (!this.fromDate) {
                return this.$toasted.show("Select From Date");
            }
            let loader = this.$loading.show();
            let payload = {
                cinema_id: this.dropDown.selectedCinemaId,
                fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
                toDate: moment(this.toDate).format("YYYY-MM-DD"),
                dataType: this.selectedDataType.type,
                isExcel
            };

            if (this.selectedDataType.type == 1) {
                payload = { ...payload, reportType: this.selectedReportType.type }

                if (this.selectedReportType.type == 1) {
                    payload = { ...payload, timeData: this.selectedTimeData }
                }
            }
            ReportsService.GetNumeroData(payload)
                .then((response) => {
                    const { data } = response;
                    if (data.status && data.Records.length > 0) {
                        this.numeroRecords = data.Records[0];
                        this.grandTotal = {
                            tax: 0,
                            admits: 0,
                            complimentaryAdmits: 0,
                            revenueNet: 0,
                            revenueGross: 0
                        }
                        this.numeroRecords.sessions.forEach(sessionsObj => {
                            sessionsObj.salesByTicketType.forEach(salesObj => {
                                this.grandTotal["tax"] += +parseFloat(salesObj.tax)
                                this.grandTotal["admits"] += +parseFloat(salesObj.admits)
                                this.grandTotal["complimentaryAdmits"] += +parseFloat(salesObj.complimentaryAdmits)
                                this.grandTotal["revenueNet"] += +parseFloat(salesObj.revenueNet)
                                this.grandTotal["revenueGross"] += +parseFloat(salesObj.revenueGross)
                            })
                        })
                        if (isExcel == "Y" && data.excelPath) {
                            window.open(data.excelPath, "_blank");
                        }
                        this.$toasted.show(data.message);
                    } else {
                        this.$toasted.show(data.message);
                    }
                    loader.hide();
                })
                .catch(this._CatchError)
                .finally(() => {
                    setTimeout(() => {
                        loader.hide();
                    }, 100);
                });
        },
    },
};
</script>

<style>
.concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
}

.concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
}

.concession-analysis-table thead th {
    padding: 5px;
    border: 1px solid #000;
}

.concession-analysis-table tbody {
    border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
    padding: 2.5px 5px;
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
}

.gcamp-tr td {
    width: 13%;
    border: 1px solid #000;
}

.swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid black;
}

.swc-report-table td {
    white-space: nowrap;
}

.swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid black !important;
}

.swc_table_header th {
    border: 1px solid black !important;
}

.no_border {
    border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/numeroReport.vue